<template>
    <div class="detail-hehuachong layout-sub-page">
        <title-bar 
            v-bind:className="'detail-hhc-title-bar'"
            v-bind:titleData="titleData"
            v-bind:midClass="true"
            v-bind:backFunc="clickBack"></title-bar>
        <div class="detail-hehuachong-main-content">
            <detail-relation class="layout-detail-relation-up"
                v-bind:allList="allList" 
                v-bind:relationList="detailRelationList[0]">
            </detail-relation>
            <div class="detail-hehuachong-content">
                <fate-panel 
                    v-bind:hideSideBar="false" 
                    v-bind:fateData="detailFateListData" 
                    v-bind:fateSideData="detailFateSideListData" 
                    v-bind:siZhuLiuNianReverse="parseInt(settingConfigData.sizhuGeShi) == 1"
                    v-bind:parentFrom="'detail'"
                    v-bind:fateInfo="detailFateInfo">
                </fate-panel>
            </div>
            <detail-relation class="layout-detail-relation-down"
                v-bind:allList="allList"
                v-bind:relationList="detailRelationList[1]">
            </detail-relation>
        </div>
    </div>
</template>

<script>
import FatePanel from '../../layouts/panel/FatePanel.vue'
import DetailRelation from '../../layouts/detail/DetailRelation.vue'
import TitleBar from '../../components/TitleBar.vue';
export default {
    name: 'DetailHeHuaChong',
    components: { FatePanel, DetailRelation, TitleBar },
    computed: {
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
        hideName() {
            return this.$store.state.detail.hideName
        },
        personInfo(){
            return this.$store.state.detail.personInfo;
        },
        detailFateInfo(){
            return this.$store.state.detail.fatefortune.fateInfo
        },
        detailFateListData(){
            var detailFateListData = [].concat(this.$store.state.detail.fatefortune.fateListData);
                detailFateListData = parseInt(this.settingConfigData.nianyueRishi) == 0 ? detailFateListData : detailFateListData.reverse();
            return detailFateListData;
        },
        detailFateSideListData(){
            var detailFateSideListData = [].concat(this.$store.state.detail.fatefortune.fateSideListData);
                detailFateSideListData = parseInt(this.settingConfigData.nianyueRishi) == 0 ? detailFateSideListData : detailFateSideListData.reverse();
            return detailFateSideListData;
        },
        allList() {
            return this.$store.state.detail.fatefortune.fateListData.concat(this.$store.state.detail.fatefortune.fateSideListData)
        },
        detailRelationList(){
            return this.$store.state.detail.detailRelationList
        },
    },
    data() {
        return {
            titleData: { titleText: '' }
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
            me.initData();
        }, 20);
    },
    methods: {
        initData() {
            var nameT = this.hideName ? '匿名' : this.personInfo.f_name;
            var sexT = this.personInfo.sex == 0 ? '男' : '女';
            this.$set(this.titleData, 'titleText', nameT+' '+sexT);
        },
        initDom() {
            this.$el.style.width = innerWidth+'px';
            this.$el.style.height = innerHeight+'px';
            var mainDom = document.getElementsByClassName('detail-hehuachong-main-content')[0];
            if(mainDom){
                mainDom.style.height = innerHeight+'px';
            }
        },
        clickBack() {
            this.$router.go(-1);
        }
    }
}
</script>